/**
 * this reflects the entites convo-ai uses when making requests to search,
 * we us it to fetch backend search relevance experiment configs to be sent to SAIN's streaming endpoint
 */
export const SAIN_ENTITIES: string[] = [
	'ati:cloud:compass:component',
	'ati:cloud:confluence:attachment',
	'ati:cloud:confluence:page',
	'ati:cloud:confluence:blogpost',
	'ati:cloud:jira:issue',
	'ati:cloud:townsquare:project',
	'ati:cloud:townsquare:goal',
	'ati:cloud:trello:card',

	// 3p sources
	'ati:cloud:graph:document',
	'ati:cloud:graph:message',
	'ati:cloud:graph:remote-link',
	'ati:cloud:graph:video',
	'ari:cloud:graph:design',
];
